import React from 'react';
import PropTypes from 'prop-types';
import BananatagButton from '../../../../componentLibrary/BananatagButton';
import * as Styled from './styles';

const DownloadButton = ({ enabled, buttonText, onClick }) =>
    enabled ? (
        <BananatagButton
            type="solid"
            size="small"
            icon="get_app"
            text={buttonText}
            onClick={onClick}
            styling={{
                borderRadius: '4px',
            }}
        />
    ) : (
        <Styled.DownloadButton onClick={onClick} disabled>
            <Styled.IconWrapper>
                <Styled.FAIcon icon="sync" />
            </Styled.IconWrapper>
            <span>DOWNLOADING</span>
        </Styled.DownloadButton>
    );

DownloadButton.propTypes = {
    enabled: PropTypes.bool.isRequired,
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default DownloadButton;
